import { faAddressBook, faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const FieldIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faAddressBook} color={props.color || 'black'} />
  )
}
